import Icon from 'components/shared/Icon/Icon';
import Disclosure from 'components/shared/Disclosure/Disclosure';
import Typography from 'components/shared/Typography/Typography';

const NewCardOption = ({ onDismiss, children }) => (
  <Disclosure
    radio
    isOpen
    disableOpen
    alwaysShowChildren
    onToggle={onDismiss}
    icon="credit-card-mono"
    iconSize={24}
    iconColor="neutral"
    iconBackground="bg-neutral-200 border border-solid border-neutral-300"
    buttonClassName="items-center gap-2 py-2.5"
    trailing={<Icon icon="close-linear" size={18} color="neutral" shade={700} />}
    customTitle={
      <Typography variant="p" size="small" weight="medium" color="neutral-800">
        New card
      </Typography>
    }>
    {children}
  </Disclosure>
);

export default NewCardOption;
